import { fromJS } from 'immutable'
import * as actionTypes from './constants'
import { LOGOUT } from '../authentication/constants'

const initialState = fromJS({
  newImportsErrors: {},
  fileUploadResponse: {},
  pdfThumbnailAsJpeg: {}
})

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FILE_UPLOADED:
      return state.set('fileUploadResponse', {
        ...action.response,
        index: action.index
      })
    case actionTypes.UPLOAD_ERROR:
      return state.setIn(['newImportsErrors', action.index], action.error)

    case actionTypes.UPLOAD_PLAN:
      return state.set('uploadingPlan', true).delete('uploadPlanError')
    case actionTypes.UPLOAD_PLAN_DONE:
      return state.set('uploadingPlan', false)
    case actionTypes.UPLOAD_PLAN_ERROR:
      return state
        .set('uploadingPlan', false)
        .set('uploadPlanError', action.error)

    case actionTypes.GET_PDF_THUMBNAIL_AS_JPEG_DONE:
      return state.setIn(['pdfThumbnailAsJpeg', action.key], action.response)
    case actionTypes.GET_PDF_THUMBNAIL_AS_JPEG_ERROR:
      return state.setIn(['pdfThumbnailAsJpegError', action.key], action.error)

    case actionTypes.UPLOAD_IMAGES:
      return state.set('uploadingImages', true)

    case actionTypes.UPLOAD_IMAGES_DONE:
      return state.set('uploadingImages', false)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default reducer
